// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post__content__tournament-result__container__tournament .baloa-table{
    color: #999999;
    padding-top: var(--space-half);
}

.post__content__tournament-result__container__tournament .baloa-subtitle-2{
    color: #4D5451;
}

.post__content__tournament-result__container {
    padding: 0 var(--space) var(--space) var(--space);
    /* background-color: var(--white-color);
    box-shadow: var(--shadow-card-2);
    padding-bottom: var(--space-and-half);
    margin-bottom: var(--space-x2); */
}

.post__content__tournament-result__container__tournament {
    padding: var(--space-and-half) var(--space) var(--space-x2) var(--space);
    background-color: var(--white-color);
    box-shadow: var(--shadow-card-2);
    padding-bottom: var(--space-and-half);
    margin-bottom: var(--space-x2);
    border-radius: 14px;;
    /* --icon-trophy */
}

.post__content__tournament-result__container .baloa-subtitle-1 {

    color: var(--primary-dark-color) !important;
    padding-top: var(--space);
}

.post__content__tournament-result__badge {
    max-width: calc( var(--space-x2) * 3.5 );
    min-width: calc( var(--space-x2) * 1 );
    border-radius: var(--space);   
    margin: var(--space-half) auto;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.025em;
    text-transform: capitalize;
    color: #2A302A;
    padding: 6px 10px;
}

.post__content__tournament-result__badge-scheduled {
    background-color: var(--new-green-color);
    color: var(--white-color);
}

.post__content__tournament-result__badge-finalized {
    background-color: var(--new-gray-background-color);
    color: var(--basic-gray-color);
}

.post__content__tournament-result__score-result {
    display: flex;
    margin-top: var(--space-x3);
}

.post__content__tournament-result__score-result span {
    font-size: 3rem;
    color: var(--secondary-color);
    border-radius: var(--space-x3);
    margin: 0 auto;
}

.post__content__tournament-result__score-result__left-col .baloa-table-column {
    text-align: center;
    color: #4D5451;
    margin-top: var(--space-half);
    
}
.post__content__tournament-result__score-result__right-col .baloa-table-column {
    text-align: center;
    color: #4D5451;
    margin-top: var(--space-half);
}

.post__content__tournament-result__score-result img {
    max-width: 50px;
    max-height: 50px;
    border-radius: 50%;
    width: 100%;
    height: 100%;
}

.post__content__tournament-result__score-result__left-col,
.post__content__tournament-result__score-result__right-col {
    width: 50%;
}

.post__content__tournament-result__score-result__score-left h3 {
    font-size: var(--space-x3) !important;
    padding-right: var(--space);
    color: var(--primary-dark-color);
    font-weight: var(--font-bold) !important;
   
}

.post__content__tournament-result__score-result__score-left .shield,
.post__content__tournament-result__score-result__score-right .shield{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* margin : 0 auto; */
}

.post__content__tournament-result__score-result__score-right .shield .icon-ball,
.post__content__tournament-result__score-result__score-left .shield .icon-ball{
    color: var(--white-color);
    padding: 5px;
    font-size: 40px;
}

.post__content__tournament-result__score-result__score-right h3 {
    font-size: var(--space-x3) !important;
    padding-left: var(--space);
    color: var(--primary-dark-color);
    font-weight: var(--font-bold) !important;

}

.post__content__tournament-result__score-result__score-left,
.post__content__tournament-result__score-result__score-right {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--space-half);
}

.post__content__tournament-result__score-result__right-col p {
    text-align: right;
    width: 100%;
    display: block;
}

.post__content__tournament-result__info-date {
    display: block;
    border-top: 1px solid var(--primary-light-color);
    /* border-bottom: 1px solid var(--primary-light-color); */
    padding: var(--space ) 0 0 0;
    margin-top: var(--space);

}

.post__content__tournament-result__info-date__col {
    display: flex;
    align-items: center;
    margin-bottom: var( --space-half );
}

.post__content__tournament-result__info-date__col span {
    font-size: 1rem;
    margin-right: var(--space-half);
    color: var(--basic-gray-color);
}

.post__content__tournament-result__info-date p{
    color: #4D5451;
}

/* .post__content__tournament-result__score-result__score-right-icon-team-vs {
   margin-left: auto;
} */

.post__content__tournament-result__vs h3 {
   font-size: var(--space-x3) !important;
   color: var(--primary-dark-color);
   font-weight: var(--font-bold) !important;   
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .post__content__tournament-result__badge-scheduled{
        font-size: var(--space);
        padding: var(--space-half);
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-info-component/LeagueTournamentInfoComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iDAAiD;IACjD;;;qCAGiC;AACrC;;AAEA;IACI,wEAAwE;IACxE,oCAAoC;IACpC,gCAAgC;IAChC,qCAAqC;IACrC,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,sCAAsC;IACtC,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;IACI,kDAAkD;IAClD,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,6BAA6B;;AAEjC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,gCAAgC;IAChC,wCAAwC;;AAE5C;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,gCAAgC;IAChC,wCAAwC;;AAE5C;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gDAAgD;IAChD,yDAAyD;IACzD,4BAA4B;IAC5B,wBAAwB;;AAE5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;;GAEG;;AAEH;GACG,qCAAqC;GACrC,gCAAgC;GAChC,wCAAwC;AAC3C;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,uBAAuB;QACvB,0BAA0B;IAC9B;AACJ","sourcesContent":[".post__content__tournament-result__container__tournament .baloa-table{\n    color: #999999;\n    padding-top: var(--space-half);\n}\n\n.post__content__tournament-result__container__tournament .baloa-subtitle-2{\n    color: #4D5451;\n}\n\n.post__content__tournament-result__container {\n    padding: 0 var(--space) var(--space) var(--space);\n    /* background-color: var(--white-color);\n    box-shadow: var(--shadow-card-2);\n    padding-bottom: var(--space-and-half);\n    margin-bottom: var(--space-x2); */\n}\n\n.post__content__tournament-result__container__tournament {\n    padding: var(--space-and-half) var(--space) var(--space-x2) var(--space);\n    background-color: var(--white-color);\n    box-shadow: var(--shadow-card-2);\n    padding-bottom: var(--space-and-half);\n    margin-bottom: var(--space-x2);\n    border-radius: 14px;;\n    /* --icon-trophy */\n}\n\n.post__content__tournament-result__container .baloa-subtitle-1 {\n\n    color: var(--primary-dark-color) !important;\n    padding-top: var(--space);\n}\n\n.post__content__tournament-result__badge {\n    max-width: calc( var(--space-x2) * 3.5 );\n    min-width: calc( var(--space-x2) * 1 );\n    border-radius: var(--space);   \n    margin: var(--space-half) auto;\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 14px;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.025em;\n    text-transform: capitalize;\n    color: #2A302A;\n    padding: 6px 10px;\n}\n\n.post__content__tournament-result__badge-scheduled {\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n}\n\n.post__content__tournament-result__badge-finalized {\n    background-color: var(--new-gray-background-color);\n    color: var(--basic-gray-color);\n}\n\n.post__content__tournament-result__score-result {\n    display: flex;\n    margin-top: var(--space-x3);\n}\n\n.post__content__tournament-result__score-result span {\n    font-size: 3rem;\n    color: var(--secondary-color);\n    border-radius: var(--space-x3);\n    margin: 0 auto;\n}\n\n.post__content__tournament-result__score-result__left-col .baloa-table-column {\n    text-align: center;\n    color: #4D5451;\n    margin-top: var(--space-half);\n    \n}\n.post__content__tournament-result__score-result__right-col .baloa-table-column {\n    text-align: center;\n    color: #4D5451;\n    margin-top: var(--space-half);\n}\n\n.post__content__tournament-result__score-result img {\n    max-width: 50px;\n    max-height: 50px;\n    border-radius: 50%;\n    width: 100%;\n    height: 100%;\n}\n\n.post__content__tournament-result__score-result__left-col,\n.post__content__tournament-result__score-result__right-col {\n    width: 50%;\n}\n\n.post__content__tournament-result__score-result__score-left h3 {\n    font-size: var(--space-x3) !important;\n    padding-right: var(--space);\n    color: var(--primary-dark-color);\n    font-weight: var(--font-bold) !important;\n   \n}\n\n.post__content__tournament-result__score-result__score-left .shield,\n.post__content__tournament-result__score-result__score-right .shield{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    /* margin : 0 auto; */\n}\n\n.post__content__tournament-result__score-result__score-right .shield .icon-ball,\n.post__content__tournament-result__score-result__score-left .shield .icon-ball{\n    color: var(--white-color);\n    padding: 5px;\n    font-size: 40px;\n}\n\n.post__content__tournament-result__score-result__score-right h3 {\n    font-size: var(--space-x3) !important;\n    padding-left: var(--space);\n    color: var(--primary-dark-color);\n    font-weight: var(--font-bold) !important;\n\n}\n\n.post__content__tournament-result__score-result__score-left,\n.post__content__tournament-result__score-result__score-right {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: var(--space-half);\n}\n\n.post__content__tournament-result__score-result__right-col p {\n    text-align: right;\n    width: 100%;\n    display: block;\n}\n\n.post__content__tournament-result__info-date {\n    display: block;\n    border-top: 1px solid var(--primary-light-color);\n    /* border-bottom: 1px solid var(--primary-light-color); */\n    padding: var(--space ) 0 0 0;\n    margin-top: var(--space);\n\n}\n\n.post__content__tournament-result__info-date__col {\n    display: flex;\n    align-items: center;\n    margin-bottom: var( --space-half );\n}\n\n.post__content__tournament-result__info-date__col span {\n    font-size: 1rem;\n    margin-right: var(--space-half);\n    color: var(--basic-gray-color);\n}\n\n.post__content__tournament-result__info-date p{\n    color: #4D5451;\n}\n\n/* .post__content__tournament-result__score-result__score-right-icon-team-vs {\n   margin-left: auto;\n} */\n\n.post__content__tournament-result__vs h3 {\n   font-size: var(--space-x3) !important;\n   color: var(--primary-dark-color);\n   font-weight: var(--font-bold) !important;   \n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .post__content__tournament-result__badge-scheduled{\n        font-size: var(--space);\n        padding: var(--space-half);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
